<template>
  <Modal v-model="editSkuCustomizationInfoModal" :title="$t('key1005782')" width="1000" :styles="{top: '30px'}"
    :before-close="handleBeforeClose" class-name="configureCustomizedContentStyles"
    :transfer="false" @on-visible-change="editSkuCustomizationInfoChange">
    <Button type="primary" style="margin-bottom: 12px" @click="addCustomizedContentBtn" :disabled="addCustomizedContentTalg">{{ $t('key1000718') }}</Button>
    <Table
      :disabled-hover="true"
      :highlight-row="false"
      border
      max-height="530"
      :loading="tableLoading"
      :columns="customizedContentColumns"
      :data="customizedContentTableData">
      <!--定制部位-->
      <template #customizedParts="{row, index}">
        <Select v-model.trim="customizedContentTableData[index].customizedParts" transfer style="width:150px;" filterable
          @on-change="(value)=>customizedPartsChange(value)">
          <Option v-for="(k, index) in customizedPartsList" :disabled="k.disabled" :key="index" :value="k.ymsProductCategoryPositionId">{{ k.parts }}</Option>
        </Select>
      </template>
      <!--素材图-->
      <template #materialImage="{row, index}">
        <span v-if="!customizedContentTableData[index].customizedParts" class="font-size-12 color-666">{{ $t('key1000719') }}</span>
        <template v-else>
          <div class="imgagesList_box" v-viewer="viewerOptions" v-if="customizedContentTableData[index].materialImageList">
            <div class="imgagesList_box_item" v-for="(path,idx) in customizedContentTableData[index].materialImageList" :key="idx">
              <div class="img_content">
                <span class="clickOnCrop_box">{{ $t('key1000720') }}</span>
                <img class="img-styles" :src="setImgPath(path, null, null, null, false)" @error="setErrorImg($event)" alt=""/>
              </div>
              <div class="flex align-items-center justify-content-center cursor mt8">
                <span class="font-size-12 themeColor mr4" style="position: relative; top: 1px;" @click="deleteImgBtn(index, idx,'materialImage')">{{ $t('key1000512') }}</span>
                <Icon type="ios-trash-outline" size="18" @click="deleteImgBtn(index, idx,'materialImage')"/>
              </div>
            </div>
            <Upload
              v-if="customizedContentTableData[index].materialImageList.length < 1"
              name="files"
              :headers="headObj"
              :show-upload-list="false"
              :on-success="(response, file, fileList) => uploadImageSuccess(response, file, fileList, index, 'materialImage')"
              :on-error="uploadFilesError"
              :before-upload="(file) => handleImgbeforeUpload(file)"
              :multiple="false"
              :action="uploadFilesUrl"
              type="drag"
              style="display: inline-block; width:75px;">
              <div class="upload-box">
                <i class="iconfont upload-icon">&#xe63e;</i>
                <p>{{ $t('key1000465') }}</p>
              </div>
            </Upload>
          </div>
        </template>
      </template>
      <!--成品预览图-->
      <template #finishedProductPreviewImage="{row, index}">
        <span v-if="!customizedContentTableData[index].customizedParts" class="font-size-12 color-666">{{ $t('key1000719') }}</span>
        <template v-else>
          <div class="imgagesList_box" v-viewer="viewerOptions" v-if="customizedContentTableData[index].finishedProductPreviewImageList">
            <div class="imgagesList_box_item" v-for="(path,idx) in customizedContentTableData[index].finishedProductPreviewImageList" :key="idx">
              <div class="img_content">
                <span class="clickOnCrop_box">{{ $t('key1000720') }}</span>
                <img class="img-styles" :src="setImgPath(path, null, null, null, false)" @error="setErrorImg($event)" alt=""/>
              </div>
              <div class="flex align-items-center justify-content-center cursor mt8">
                <span class="font-size-12 themeColor mr4" style="position: relative; top: 1px;" @click="deleteImgBtn(index, idx,'finishedProductPreviewImage')">{{ $t('key1000512') }}</span>
                <Icon type="ios-trash-outline" size="18" @click="deleteImgBtn(index, idx,'finishedProductPreviewImage')"/>
              </div>
            </div>
            <Upload
              v-if="customizedContentTableData[index].finishedProductPreviewImageList.length < 2"
              name="files"
              :headers="headObj"
              :show-upload-list="false"
              :on-success="(response, file, fileList) => uploadImageSuccess(response, file, fileList, index, 'finishedProductPreviewImage')"
              :on-error="uploadFilesError"
              :before-upload="(file) => handleImgbeforeUpload(file)"
              multiple
              :action="uploadFilesUrl"
              type="drag"
              style="display: inline-block; width:75px;">
              <div class="upload-box">
                <i class="iconfont upload-icon">&#xe63e;</i>
                <p>{{ $t('key1000465') }}</p>
              </div>
            </Upload>
          </div>
        </template>
      </template>
    </Table>
    <template #footer>
      <Button @click="cancelBtn">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="editSkuCustomizationInfoBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'editSkuCustomizationInfoModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      uploadFilesUrl: api.erpCommon_uploadFiles + '?basePath=yms-distributor-service&action="uploadimage"',
      editSkuCustomizationInfoModal: false,
      customizedContentColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000692'),
          key: 'customizedParts',
          minWidth: 150,
          align: 'left',
          renderHeader: (h, params) => {
            return h('span', {class: 'required'}, params.column.title);
          },
          slot: 'customizedParts'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693'),
          key: 'materialImage',
          minWidth: 300,
          align: 'left',
          renderHeader: (h, params) => {
            return h('span', {class: 'required'}, params.column.title);
          },
          slot: 'materialImage'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694'),
          renderHeader: (h, params) => {
            return h('span', {class: 'required'}, params.column.title);
          },
          key: 'finishedProductPreviewImage',
          minWidth: 300,
          align: 'left',
          slot: 'finishedProductPreviewImage'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 100,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                isShowMoreBtn: false,
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.customizedContentTableData.length > 1,
                    clickFn: () => {
                      v.deleteCustomizedContentBtn(params.index);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      customizedContentTableData: [],
      customizedPartsList: [],
      detailsData: {}
    };
  },
  computed: {
    addCustomizedContentTalg() {
      return this.customizedPartsList.every(item => item.disabled === true) ||
        this.customizedContentTableData.length >= this.customizedPartsList.length;
    },
  },
  methods: {
    // 初始化数据
    initEditSkuCustomizationData(obj) {
      this.detailsData = JSON.parse(JSON.stringify(obj));
      let ymsProductGoodsPositions = obj.ymsProductGoodsPositions || [];
      ymsProductGoodsPositions.map((item) => {
        item.disabled = false;
      });
      this.customizedPartsList = ymsProductGoodsPositions; // 选择部位的基础数据
      let productGoodsSpecifications = obj.productGoodsSpecifications || [];
      let newList = [];
      let list = [];
      productGoodsSpecifications.map((k) => {
        let ymsProductGoodsSpecificationImagesList = k.ymsProductGoodsSpecificationImages || [];
        ymsProductGoodsSpecificationImagesList.map((j) => {
          newList.push(j);
        });
      });
      this.detailsData.ymsProductGoodsSpecificationImagesList = newList;
      let partBosList = this.handerGrouping(newList, function (item) {
        return [item.parts];
      }, 'parts', 'imageBos');
      partBosList.map((item) => {
        let materialImageList = item.imageBos.filter(ele => ele.imageType === 1);
        let finishedProductPreviewImageList = item.imageBos.filter(ele => ele.imageType === 2);
        list.push({
          customizedParts: ymsProductGoodsPositions.filter((ele) => ele.parts === item.parts)[0].ymsProductCategoryPositionId,
          materialImageList: materialImageList.map(ele => ele.path),
          finishedProductPreviewImageList: finishedProductPreviewImageList.map(ele => ele.path)
        });
      });
      this.customizedContentTableData = list;
      this.customizedPartsList.forEach(item => {
        item.disabled = false;
        this.customizedContentTableData.map((ele) => {
          if (item.ymsProductCategoryPositionId === ele.customizedParts) {
            item.disabled = true;
          }
        });
      });

      console.log('======customizedContentTableData======', this.customizedContentTableData);
      this.editSkuCustomizationInfoModal = true;
    },
    // 取消按钮
    cancelBtn() {
      this.handleBeforeClose().then(() => {
        this.editSkuCustomizationInfoModal = false;
      });
    },
    // 上传图片之前的校验
    handleImgbeforeUpload(file, type) {
      const maxSize = 5;
      return new Promise((resolve, reject) => {
        const isJPG = ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type);
        const isLtMax = file.size / 1024 / 1024 <= maxSize;

        if (!isJPG) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000710'));
          reject();
        }
        if (!isLtMax) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000711'));
          reject();
        }
        resolve();
      });
    },
    // 上传图片成功
    uploadImageSuccess(response, file, fileList, index, type) {
      let name = type === 'materialImage' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694');
      if (response.code === 0 && response.datas) {
        let url = response.datas[0];
        if (url) {
          this.customizedContentTableData[index][type + 'List'].push(url);
          let length = 2;
          if (type === 'materialImage') {
            length = 1;
          }
          this.customizedContentTableData[index][type + 'List'] = this.customizedContentTableData[index][type + 'List'].slice(0, length);
        }
        this.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000683')}`);
      } else {
        this.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000684')}`);
      }
    },
    // 删除图片
    deleteImgBtn(index, imgIndex, type) {
      this.customizedContentTableData[index][type + 'List'].splice(imgIndex, 1);
      this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000712'));
      this.$forceUpdate();
    },
    // 选择定制部位
    customizedPartsChange(value) {
      this.customizedPartsList.forEach(item => {
        item.disabled = false;
        this.customizedContentTableData.map((ele) => {
          if (item.ymsProductCategoryPositionId === ele.customizedParts) {
            item.disabled = true;
          }
        });
      });
    },
    // 添加定制部位
    addCustomizedContentBtn() {
      this.customizedContentTableData.push({
        customizedParts: null,
        materialImageList: [],
        finishedProductPreviewImageList: []
      });
    },
    // 删除定制部位
    deleteCustomizedContentBtn(index) {
      this.customizedContentTableData.splice(index, 1);
      this.customizedPartsList.forEach(item => {
        item.disabled = false;
        this.customizedContentTableData.map((ele) => {
          if (item.ymsProductCategoryPositionId === ele.customizedParts) {
            item.disabled = true;
          }
        });
      });
      this.$forceUpdate();
    },
    // 重置数据
    resetData() {
      this.customizedContentTableData = [];
      this.customizedPartsList = [];
      this.detailsData = {};
    },
    // 关闭之前的二次弹窗提示确认
    handleBeforeClose() {
      let v = this;
      return new Promise((resolve, reject) => {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000701'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000702'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.resetData();
            resolve();
          },
          onCancel: () => {
            reject();
          }
        });
      });
    },
    // 保存
    editSkuCustomizationInfoBtn() {
      let v = this;
      const fieldList = [
        {key: 'customizedParts', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000692')},
        {key: 'materialImageList', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693')},
        {key: 'finishedProductPreviewImageList', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694')}
      ];
      for (let i = 0; i < v.customizedContentTableData.length; i++) {
        const item = v.customizedContentTableData[i];
        for (const field of fieldList) {
          const value = item[field.key];
          if ((field.key !== 'customizedParts' && (!value || value.length === 0)) || (field.key === 'customizedParts' && !value)) {
            v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000679')}${i + 1}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000680')}${field.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000681')}`);
            return;
          }
        }
      }
      const handleImgList = (imgData, type) => {
        let {ymsProductGoodsSpecificationImagesList} = v.detailsData;
        let newList = imgData.map((k, index) => {
          let md5 = null;
          ymsProductGoodsSpecificationImagesList.map((j) => {
            if (j.path === k) {
              md5 = j.md5;
            }
          });
          return {
            path: v.setImgPath(k, 'distributor', null, null, false),
            imageType: type,
            sortNo: index + 1,
            md5: md5
          };
        });
        return newList;
      };
      let partBos = [];
      v.customizedContentTableData.map((item) => {
        let parts = v.customizedPartsList.filter(ele => ele.ymsProductCategoryPositionId === item.customizedParts)[0].parts;
        let finishedProductPreviewImageList = item.finishedProductPreviewImageList || [];
        let materialImageList = item.materialImageList || [];
        partBos.push({
          parts,
          imageBos: [
            ...handleImgList(materialImageList, 1),
            ...handleImgList(finishedProductPreviewImageList, 2)
          ]
        });
      });
      let list = [{
        partBos,
        ymsProductGoodsId: v.detailsData.ymsProductGoodsId,
      }];
      v.axios.post(api.post_ymsDistributorProductInfo_updateCustomizationProducts, list,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001187')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
          v.editSkuCustomizationInfoModal = false;
          v.$emit('updateData', true);
        }
      });
    },
    // 监听弹窗
    editSkuCustomizationInfoChange(value) {
      if (!value) {
        this.resetData();
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less" scoped>
/deep/ .configureCustomizedContentStyles {

  .imgagesList_box {
    margin: 8px 0;
    display: flex;
    flex-wrap: wrap;
    position: relative;

    .imgagesList_box_item {
      margin: 0 8px 0 0;

      .img_content {
        position: relative;
        cursor: pointer;
        width: 75px;
        height: 75px;

        .clickOnCrop_box {
          width: 100%;
          height: 20px;
          line-height: 20px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 10;
          text-align: center;
          font-size: 12px;
          color: #fff;
          background-color: #ada9a9;
          display: none;
        }

        &:hover {
          .clickOnCrop_box {
            display: inline-block;
          }
        }
      }

      .img-styles {
        width: 75px;
        height: 75px;
        object-fit: cover;
        border: 1px solid #ddd;
      }
    }

    .upload-box {
      width: 75px;
      height: 75px;
      color: #999999;
      transition: color 0.1s ease-in;
      background: #fff;
      border: 1px dashed #dcdee2;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .upload-icon {
        font-size: 30px;
        display: block;
      }

      &:hover {
        color: #666666;
      }
    }

    .select_customized {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
}
</style>
